import { GOOGLE_ANALYTICS } from 'bento-ordering/base/constants/tracking';

const initialState = {
  gaInitialized: false
};

const trackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GOOGLE_ANALYTICS:
      return {
        ...state,
        gaInitialized: true
      };

    default:
      return { ...state };
  }
};

export default trackingReducer;
